<ngx-spinner
  bdColor="rgba(0,0,0,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
  [fullScreen]="true">
</ngx-spinner>
<router-outlet />
